/* Fixel · menú móvil (drill-down de Mode) — accesibilidad y foco.
   No cambia el comportamiento de Mode (abrir/Atrás/cerrar/bloqueo de scroll/trap de foco):
   solo añade role="dialog" + aria-modal, aria-expanded en los botones de menú y
   el foco al entrar/salir del 2º nivel. Solo actúa si existe el menú Fixel [data-fx-mnav]. */
(function () {
  if (window.__fxMnav) return;
  function init() {
    var drawer = document.querySelector('.mobile-navigation-drawer');
    if (!drawer || !drawer.querySelector('[data-fx-mnav]') || drawer.__fxMnav) return;
    drawer.__fxMnav = window.__fxMnav = 1;

    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    if (!drawer.getAttribute('aria-label')) drawer.setAttribute('aria-label', 'Menú');

    var back = drawer.querySelector('.mobile-nav-back');
    if (back && !back.querySelector('.fx-mnav__back-txt')) {
      back.setAttribute('aria-label', 'Atrás');
      var bt = document.createElement('span'); bt.className = 'fx-mnav__back-txt'; bt.setAttribute('aria-hidden', 'true'); bt.textContent = 'Atrás';
      back.appendChild(bt);
    }
    var closeBtn = drawer.querySelector('.navigation__mobile-header .mobile-nav-toggle');

    /* Botón hamburguesa de la cabecera (fuera del drawer): aria-expanded/aria-controls */
    var toggles = Array.prototype.filter.call(document.querySelectorAll('.mobile-nav-toggle'), function (t) { return !drawer.contains(t); });
    var wasOpen = false;
    function syncExpanded() {
      var open = document.body.classList.contains('reveal-mobile-nav');
      if (wasOpen && !open && toggles[0] && (drawer.contains(document.activeElement) || document.activeElement === document.body)) {
        var tg = toggles.filter(function (t) { return t.offsetParent; })[0] || toggles[0];
        setTimeout(function () { tg.focus(); }, 30);
      }
      wasOpen = open;
      toggles.forEach(function (t) {
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (drawer.id) t.setAttribute('aria-controls', drawer.id);
      });
      if (!open) closePanels(false);
    }
    new MutationObserver(syncExpanded).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    syncExpanded();

    /* 2º nivel */
    var lastOpener = null;
    function closePanels(focusOpener) {
      drawer.querySelectorAll('[data-fx-mnav-open][aria-expanded="true"]').forEach(function (a) { a.setAttribute('aria-expanded', 'false'); });
      if (focusOpener && lastOpener) { var o = lastOpener; setTimeout(function () { o.focus(); }, 360); }
    }
    drawer.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-fx-mnav-open]');
      if (opener) {
        opener.setAttribute('aria-expanded', 'true');
        lastOpener = opener;
        setTimeout(function () { if (back) back.focus(); }, 360);
        return;
      }
      if (e.target.closest('.mobile-nav-back')) closePanels(true);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !document.body.classList.contains('reveal-mobile-nav')) return;
      e.preventDefault();
      if (drawer.classList.contains('mobile-navigation-drawer--child-open') && back) back.click();
      else if (closeBtn) closeBtn.click();
    });
    drawer.addEventListener('keydown', function (e) {
      var opener = e.target.closest && e.target.closest('[data-fx-mnav-open]');
      if (opener && e.key === ' ') { e.preventDefault(); opener.click(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
